/* ==========================================================================
   Shop Drawer Menu — behaviour
   Add this file to Assets as shop-drawer.js
   ========================================================================== */

window.ShopDrawer = (function () {

  var initialized = {};

  function setup(wrapper) {
    var drawerId = wrapper.id;
    if (initialized[drawerId]) return; // avoid double-binding
    initialized[drawerId] = true;

    var overlay = wrapper.querySelector('[data-shop-drawer-overlay]');
    var closeBtn = wrapper.querySelector('[data-shop-drawer-close]');
    var mainPanel = wrapper.querySelector('[data-panel="main"]');
    var subTriggers = wrapper.querySelectorAll('[data-drawer-subtrigger]');
    var backButtons = wrapper.querySelectorAll('[data-drawer-back]');

    function openDrawer() {
      wrapper.setAttribute('data-open', 'true');
      wrapper.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      wrapper.setAttribute('data-open', 'false');
      wrapper.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resetPanels();
    }

    function resetPanels() {
      wrapper.querySelectorAll('.shop-drawer__panel--sub').forEach(function (p) {
        p.classList.remove('is-active');
      });
      if (mainPanel) mainPanel.classList.remove('is-shifted');
    }

    function openSubPanel(id) {
      var target = wrapper.querySelector('[data-panel="' + id + '"]');
      if (!target) return;
      if (mainPanel) mainPanel.classList.add('is-shifted');
      target.classList.add('is-active');
      target.scrollTop = 0;
    }

    function closeSubPanels() {
      resetPanels();
    }

    if (overlay) overlay.addEventListener('click', closeDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var anySubActive = wrapper.querySelector('.shop-drawer__panel--sub.is-active');
      if (anySubActive) {
        closeSubPanels();
      } else {
        closeDrawer();
      }
    });

    subTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-drawer-subtrigger');
        openSubPanel(id);
      });
    });

    backButtons.forEach(function (btn) {
      btn.addEventListener('click', closeSubPanels);
    });

    wrapper._shopDrawerOpen = openDrawer;
    wrapper._shopDrawerClose = closeDrawer;
  }

  function setupAll() {
    document.querySelectorAll('[data-shop-drawer]').forEach(setup);
  }

  // Event delegation: works no matter when/where the "Shop" trigger
  // element is added to the DOM (header, mobile menu, re-rendered nav, etc.)
  // Matches either an explicit data-shop-drawer-toggle attribute, OR
  // an <a>/<button> whose visible text matches the configured trigger text.
  function getTriggerTexts() {
    var texts = [];
    document.querySelectorAll('[data-shop-drawer]').forEach(function (wrapper) {
      var t = wrapper.getAttribute('data-trigger-text');
      if (t) texts.push(t.trim().toLowerCase());
    });
    return texts;
  }

function bindDelegatedTrigger() {
  document.addEventListener('click', function (e) {
    var explicitTrigger = e.target.closest('[data-shop-drawer-toggle]');
    var clickable = e.target.closest('a, button');
    var label = clickable ? (clickable.textContent || '').trim().toLowerCase() : '';

    var wrappers = document.querySelectorAll('[data-shop-drawer]');
    if (!wrappers.length) return;

    var targets = [];

    if (explicitTrigger) {
      // Explicit attribute: open every drawer (backward compatible)
      targets = Array.prototype.slice.call(wrappers);
    } else if (label !== '') {
      // Text match: open ONLY the drawer(s) whose configured trigger text matches
      targets = Array.prototype.filter.call(wrappers, function (wrapper) {
        var t = wrapper.getAttribute('data-trigger-text');
        return t && t.trim().toLowerCase() === label;
      });
    }

    if (!targets.length) return;

    e.preventDefault();

    targets.forEach(function (wrapper) {
      setup(wrapper);
      if (wrapper._shopDrawerOpen) wrapper._shopDrawerOpen();
    });
  });
}

  function boot() {
    setupAll();
    bindDelegatedTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot(); // DOM already ready (e.g. script executed late/async)
  }

  return { init: setupAll };

})();